

var AppConfig = {
    env: process.env.REACT_APP_ENV,

    apiUrl:  process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === "prd" ? 'https://api.data-cbinsights.com' :
        process.env.REACT_APP_ENV ? `https://${process.env.REACT_APP_ENV}-api.data-cbinsights.com` : 'http://localhost:5000',
}

export default AppConfig;